<template>
  <div v-if="sportProgram !== null" class="content-wrapper" style="min-height: 481px;">
    <section class="content-header">
      <h1>
        {{ sportProgram.name[$root.$i18n.locale] }}
      </h1>
      <ol class="breadcrumb">
        <li><i class="fa fa-dashboard"></i> <a href="../">Dashboard</a></li>
        <li><a href="../programs">{{ $t('trainings.title') }}</a></li>
        <li class="active">{{ sportProgram.camp.name[$root.$i18n.locale] }}</li>
      </ol>
    </section>

    <section class="content container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="nav-tabs-custom">
          <ul class="nav nav-tabs">
            <li v-if="!isBackoffice()" class="active">
              <a href="#tab_1" data-toggle="tab" aria-expanded="true">
                {{ $t('trainings.blocks.description') }}</a>
            </li>

            <li v-if="isBackoffice()" class="dropdown">
              <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                {{ $t('trainings.blocks.description') }} <span class="caret"></span>
              </a>
              <ul class="dropdown-menu">
                <li>
                  <a data-toggle="tab" aria-expanded="false" href="#tab_1">
                    {{ $t('trainings.blocks.description') }}
                  </a>
                </li>
                <li>
                  <a data-toggle="tab" aria-expanded="false" href="#tab_2">
                    Source Description
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#tab_3" data-toggle="tab" aria-expanded="false">
                {{$t('trainings.blocks.arrivals')}}
              </a>
            </li>
            <li>
              <a href="#tab_4" data-toggle="tab" aria-expanded="false">
                {{$t('trainings.blocks.residences')}}
              </a>
            </li>
            <li>
              <a href="#tab_5" data-toggle="tab" aria-expanded="false">
                {{$t('trainings.blocks.transfers')}}
              </a>
            </li>
            <li>
              <a href="#tab_6" data-toggle="tab" aria-expanded="false">
                {{$t('trainings.blocks.additional-services')}}
              </a>
            </li>
            <li>
              <a href="#tab_7" data-toggle="tab" aria-expanded="false">
                {{$t('trainings.blocks.photos')}}
              </a>
            </li>
            <li>
              <a href="#tab_8" data-toggle="tab" aria-expanded="false">
                {{$t('trainings.blocks.videos')}}
              </a>
            </li>
            <li>
              <a href="#tab_9" v-on:click="openFaqs(sportProgram)" data-toggle="tab" aria-expanded="false">
                {{$t('trainings.blocks.faqs')}}
              </a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane active" id="tab_1">
              <TrainingDescriptionComponent
                v-bind:sport-types="sportTypes"
                v-bind:current-training="sportProgram"
                v-bind:countries="countries"
                v-bind:cities="cities">
              </TrainingDescriptionComponent>
            </div>
            <div v-if="isBackoffice()" class="tab-pane" id="tab_2">
              <TrainingSourceDescriptionComponent
                v-bind:sport-types="sportTypes"
                v-bind:current-training="sportProgram">
              </TrainingSourceDescriptionComponent>
            </div>
            <div class="tab-pane" id="tab_3">
              <TrainingArrivalsComponent
                v-bind:current-training="sportProgram">
              </TrainingArrivalsComponent>
            </div>
            <div class="tab-pane" id="tab_4">
              <TrainingResidencesComponent
                v-bind:current-training="sportProgram">
              </TrainingResidencesComponent>
            </div>
            <div class="tab-pane" id="tab_5">
              <TrainingTransfersComponent
                v-bind:current-training="sportProgram">
              </TrainingTransfersComponent>
            </div>
            <div class="tab-pane" id="tab_6">
              <TrainingAdditionalServicesComponent
                v-bind:current-training="sportProgram">
              </TrainingAdditionalServicesComponent>
            </div>
            <div class="tab-pane" id="tab_7">
              <TrainingPhotosComponent
                v-bind:current-training="sportProgram">
              </TrainingPhotosComponent>
            </div>
            <div class="tab-pane" id="tab_8">
              <TrainingVideosComponent
                v-bind:current-training="sportProgram">
              </TrainingVideosComponent>
            </div>
            <div class="tab-pane" id="tab_9">
              <TrainingFaqsComponent
                v-bind:current-training="sportProgram">
              </TrainingFaqsComponent>
            </div>
          </div>
        </div>
      </div>
    </div>
    </section>
  </div>
</template>

<script>
import TrainingDescriptionComponent from './TrainingDescriptionModal';
import TrainingSourceDescriptionComponent from './TrainingSourceDescription';
import TrainingArrivalsComponent from './TrainingArrivals';
import TrainingResidencesComponent from './TrainingResidences';
import TrainingTransfersComponent from './TrainingTransfers';
import TrainingAdditionalServicesComponent from './TrainingAdditionalServices';
import TrainingPhotosComponent from './TrainingPhotos';
import TrainingVideosComponent from './TrainingVideos';
import TrainingFaqsComponent from './TrainingFaqs';

export default {
  name: 'SportProgramContent',
  props: {
    sportProgram: Object,
    countries: Array,
    cities: Array,
    sportTypes: Array
  },
  components: {
    TrainingDescriptionComponent,
    TrainingSourceDescriptionComponent,
    TrainingArrivalsComponent,
    TrainingResidencesComponent,
    TrainingTransfersComponent,
    TrainingAdditionalServicesComponent,
    TrainingPhotosComponent,
    TrainingVideosComponent,
    TrainingFaqsComponent
  },
  data () {
    return {

    };
  },
  methods: {
    isBackoffice: function () {
      return window.application !== 'cabinet';
    },
    openFaqs: function () {
      this.$root.$emit('showFaqs', this.sportProgram.id, this.sportProgram.camp.id);
    }
  }
};
</script>

<style scoped>

</style>
